//
//
//
//

export default {
  name: 'PreviewShadow',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
